import {SCRIPT_HEADER_NOTICES} from './scriptHeaderNotices';

export function isStaticBanner(line: string): boolean {
  return SCRIPT_HEADER_NOTICES.some(header => line.includes(header));
}
